// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","listInfrastructure":"infrastructure_listInfrastructure__Y0Wwt","cheked":"infrastructure_cheked__j9khN"};